import { render, staticRenderFns } from "./OrdersInfoDialog.vue?vue&type=template&id=64a3a96c&scoped=true"
import script from "./OrdersInfoDialog.vue?vue&type=script&lang=js"
export * from "./OrdersInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./OrdersInfoDialog.vue?vue&type=style&index=0&id=64a3a96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3a96c",
  null
  
)

export default component.exports